import React from 'react'
import { Dropdown } from 'react-bootstrap'

const ANALYTICS_PDF_PERIOD_OPTIONS = [
  { value: '24h', label: 'Last 24 hours' },
  { value: '7d', label: 'Last 7 days' },
  { value: '30d', label: 'Last 30 days' },
  { value: '6mo', label: 'Last 6 months' },
  { value: '12mo', label: 'Last 12 months' }
]

const AnalyticsPdfPeriodDropdown = ({ selectedPeriod, onSelect }) => (
  <Dropdown>
    <Dropdown.Toggle variant="outline-secondary" size="sm">
      {ANALYTICS_PDF_PERIOD_OPTIONS.find((opt) => opt.value === selectedPeriod)?.label || 'Last 30 days'}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      {ANALYTICS_PDF_PERIOD_OPTIONS.map((option) => (
        <Dropdown.Item
          key={option.value}
          active={selectedPeriod === option.value}
          onClick={() => onSelect(option.value)}
        >
          {option.label}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
)

export default AnalyticsPdfPeriodDropdown
